import { FormFieldValidator, ValidationResult } from './FormFieldValidator';
import { FormFieldValue } from '../types';

export class CompositeOrderedValidator extends FormFieldValidator {
  private validators: FormFieldValidator[];

  constructor(...validators: FormFieldValidator[]) {
    super(false, null, null);
    this.validators = validators.filter((validator) => !!validator);
  }

  async validate(value: FormFieldValue): Promise<ValidationResult> {
    const validationResult = await this.doNextValidation(0, value);
    return validationResult;
  }

  async doNextValidation(idx: number, value: FormFieldValue): Promise<ValidationResult> {
    if (this.validators.length < 1 || idx >= this.validators.length) {
      return ValidationResult.create(true);
    }

    const validationResult = await this.validators[idx].validate(value);

    if (validationResult.isValid) {
      return this.doNextValidation(++idx, value);
    } else {
      return validationResult;
    }
  }
}
